import { api } from '@/lib/api'
import type { Invoice, PaginatedResponse } from '@/types'
import type { PaymentListItem } from '@/hooks/usePayments'

export async function fetchAllInvoices(dateFrom?: string, dateTo?: string, status?: string, includeItems?: boolean, propertyId?: number): Promise<Invoice[]> {
  const all: Invoice[] = []
  let page = 1
  let hasMore = true
  while (hasMore) {
    const params: Record<string, unknown> = { page, per_page: 100 }
    // EP-97: export/print means the COMPLETE set (bounded only by an explicit
    // date range) — escape the list endpoint's latest-period default.
    params.all_periods = 'true'
    if (dateFrom) params.date_from = dateFrom
    if (dateTo) params.date_to = dateTo
    if (status) params.status = status
    if (includeItems) params.include_items = 'true'
    // MON-18 B: scope the export to the header's selected building. Omitted
    // entirely (every building) when none is selected.
    if (propertyId) params.property_id = propertyId
    const { data } = await api.get<PaginatedResponse<Invoice[]>>('/api/invoices', { params })
    all.push(...data.data)
    hasMore = data.meta.current_page < data.meta.total_pages
    page++
  }
  return all
}

export async function fetchAllPayments(dateFrom?: string, dateTo?: string, includeItems?: boolean, propertyId?: number): Promise<PaymentListItem[]> {
  const all: PaymentListItem[] = []
  let page = 1
  let hasMore = true
  while (hasMore) {
    const params: Record<string, unknown> = { page, per_page: 100 }
    // EP-97: export/print means the COMPLETE set (bounded only by an explicit
    // date range) — escape the list endpoint's latest-period default.
    params.all_periods = 'true'
    if (dateFrom) params.from = dateFrom
    if (dateTo) params.to = dateTo
    if (includeItems) params.include_items = 'true'
    // MON-18 B: scope the export to the header's selected building. Omitted
    // entirely (every building) when none is selected.
    if (propertyId) params.property_id = propertyId
    const { data } = await api.get<PaginatedResponse<PaymentListItem[]>>('/api/payments', { params })
    all.push(...data.data)
    hasMore = data.meta.current_page < data.meta.total_pages
    page++
  }
  return all
}
